// Promo ETF modal — UCITS pages.
// Opens #promo-etf-modal when the user scrolls past .etf-overview-wrapper.
// Bails silently if either element is missing.
// Closed via close button, backdrop click, or Esc.

const MODAL_ID = 'promo-etf-modal';
const TRIGGER_SELECTOR = '.etf-overview-wrapper';
// How many pixels into the trigger element the user needs to scroll before
// the modal opens. Negative because we measure rect.top relative to the
// viewport top: when the top edge is still below the viewport top, rect.top > 0;
// once the top edge has scrolled past and 50px of the element is above the
// viewport top, rect.top === -50.
const SCROLL_THRESHOLD_PX = -50;

function init() {
    const modal = document.getElementById(MODAL_ID);
    const trigger = document.querySelector(TRIGGER_SELECTOR);
    if (!modal || !trigger) return;

    let shown = false;
    let ticking = false;

    const open = () => {
        if (shown) return;
        shown = true;
        modal.classList.add('show');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('modal-open');
        window.removeEventListener('scroll', onScroll);
    };

    const close = () => {
        modal.classList.remove('show');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('modal-open');
    };

    // Combined height of the fixed bars at the top of the viewport (site header +
    // any sticky-to-top element). Computed at scroll time because the site header
    // may collapse or expand as the user scrolls.
    // If either element is missing, that contribution is 0 — we still work, just
    // with a smaller offset.
    function getFixedTopOffset() {
        const siteHeader = document.querySelector('header.site-header');
        const stickyTop = document.getElementById('populateHeroNav');
        const headerH = siteHeader ? siteHeader.getBoundingClientRect().height : 0;
        const stickyH = stickyTop ? stickyTop.getBoundingClientRect().height : 0;
        return headerH + stickyH;
    }

    // rAF-throttled — runs at most once per animation frame, but fires
    // immediately during scroll instead of waiting for the user to stop.
    function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
            const fixedOffset = getFixedTopOffset();
            // rect.top is measured from the viewport top. We want to detect "the
            // trigger's top edge has scrolled past the bottom of the fixed bar
            // stack, plus SCROLL_THRESHOLD_PX more". That's: rect.top <= fixedOffset + SCROLL_THRESHOLD_PX
            // (with SCROLL_THRESHOLD_PX negative, this is fixedOffset - 50).
            if (trigger.getBoundingClientRect().top <= fixedOffset + SCROLL_THRESHOLD_PX) {
                open();
            }
            ticking = false;
        });
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('show')) close();
    });

    modal.addEventListener('click', (e) => {
        // Prevent the click from bubbling to document-level handlers — notably
        // newsletter-modal's "click outside / on .dialog__close closes me"
        // handler, which would otherwise dismiss the newsletter modal AND
        // consume one of its cooldown attempts when the user interacts with
        // the promo modal.
        e.stopPropagation();

        if (e.target.closest('.js-promo-etf-modal-close') || e.target === modal) {
            close();
        }
    });

    window.addEventListener('scroll', onScroll, { passive: true });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
